import * as React from "react";
import { Box } from "@mui/material";
import { MetricCard } from "./MetricCard";

export interface MetricGridItem {
  label: string;
  value?: string | number | boolean | null;
  render?: React.ReactNode;
}

interface MetricGridProps {
  metrics: MetricGridItem[];
}

/**
 * Compact responsive grid of `MetricCard`s within a single card - distinct
 * from `InformationGrid` (which lays out whole page-level section cards).
 * Purely presentational: arranges already-fetched values, computes nothing.
 */
export function MetricGrid({ metrics }: MetricGridProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        },
        gap: 2,
      }}
    >
      {metrics.map((metric) => (
        <MetricCard key={metric.label} label={metric.label} value={metric.value} render={metric.render} />
      ))}
    </Box>
  );
}
